export default __webpack_public_path__ + "static/media/11.37e23bc0.jpg";